import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import BiomedicalDivisionForm from "@preferredMedical/Widgets/BiomedicalDivisionForm/BiomedicalDivisionForm";
import * as React from "react";

const enum fields {
    backgroundColor = "backgroundColor",
    emailRecipients = "emailRecipients",
    introductoryText = "introductoryText",
    productNames = "productNames",
    businessTypes = "businessTypes"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.emailRecipients]: string;
    };
}

type Props = WidgetProps & OwnProps;

const BiomedicalDivisionFormWidget: React.FC<Props> = ({ fields }) => {
    const { backgroundColor, introductoryText, emailRecipients, businessTypes, productNames } = fields;

    return (
        <StyledWrapper>
            <BiomedicalDivisionForm
                emailRecipients={emailRecipients}
                widgetSettings={{ backgroundColor, introductoryText, businessTypes, productNames }}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BiomedicalDivisionFormWidget,
    definition: {
        displayName: "Biomedical Division Form",
        group: "My Account",
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                displayName: "Background Color",
                editorTemplate: "ColorPickerField",
                defaultValue: "#333333",
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.emailRecipients,
                displayName: "Email recipients (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.introductoryText,
                displayName: "Introductory Text",
                editorTemplate: "RichTextField",
                fieldType: "General",
                defaultValue:
                    "Our Biomedical Division is your one stop shop for all your infusion equipment and supply needs.",
                isRequired: true,
            },
            {
                name: fields.businessTypes,
                displayName: "Business Types (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue:
                    "Allergy\n" +
                    "Anti-Aging/Wellness\n" +
                    "Chelation\n" +
                    "Compounding Pharmacy\n" +
                    "Consultant\n" +
                    "Correctional Facility\n" +
                    "Dental\n" +
                    "Dialysis Center\n" +
                    "Distributor\n" +
                    "DME/HME\n" +
                    "Education\n" +
                    "EMS\n" +
                    "Government\n" +
                    "Home Infusion\n" +
                    "Hospice\n" +
                    "Hospital/Medical Center\n" +
                    "Imaging Center\n" +
                    "Industrial\n" +
                    "Infectious Disease\n" +
                    "LTC Pharmacy\n" +
                    "Manufacturer\n" +
                    "Neurology\n" +
                    "Nursing Services\n" +
                    "Oncology\n" +
                    "Ophthalmology\n" +
                    "Other\n" +
                    "Pain Management\n" +
                    "Physician\n" +
                    "Research & Development\n" +
                    "Retail Pharmacy\n" +
                    "Rheumatology\n" +
                    "Skilled Nursing\n" +
                    "Specialty Pharmacy\n" +
                    "Surgery Center\n" +
                    "Urgent Care Center\n" +
                    "Vein & Vascular\n" +
                    "Veterinary",
                isRequired: true,
            },
            {
                name: fields.productNames,
                displayName: "Product Names (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true
            }
        ],
    },
};

export default widgetModule;
